import { render, staticRenderFns } from "./CError.vue?vue&type=template&id=909e1d30&scoped=true"
import script from "./CError.vue?vue&type=script&lang=js"
export * from "./CError.vue?vue&type=script&lang=js"
import style0 from "./CError.vue?vue&type=style&index=0&id=909e1d30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909e1d30",
  null
  
)

export default component.exports